var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsOptional, IsString, MaxLength, ValidateNested, } from 'class-validator';
import { AccidentState } from '../../../enums';
import { CreateVehicleAccidentPersonDto } from './create-vehicle-accident-person.dto';
export class CreateVehicleAccidentDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleAccidentDto.prototype, "managerId", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleAccidentDto.prototype, "vehicleId", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVehicleAccidentDto.prototype, "branchId", void 0);
__decorate([
    IsEnum(AccidentState),
    __metadata("design:type", String)
], CreateVehicleAccidentDto.prototype, "state", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", String)
], CreateVehicleAccidentDto.prototype, "date", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleAccidentDto.prototype, "location", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateVehicleAccidentDto.prototype, "detail", void 0);
__decorate([
    IsString(),
    IsOptional(),
    MaxLength(3000),
    __metadata("design:type", String)
], CreateVehicleAccidentDto.prototype, "note", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateVehicleAccidentPersonDto),
    __metadata("design:type", CreateVehicleAccidentPersonDto)
], CreateVehicleAccidentDto.prototype, "personA", void 0);
__decorate([
    ValidateNested(),
    Type(() => CreateVehicleAccidentPersonDto),
    __metadata("design:type", CreateVehicleAccidentPersonDto)
], CreateVehicleAccidentDto.prototype, "personB", void 0);
